import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PropertyAnalytics {
  total_pv_kwh: number;
  total_load_kwh: number;
  total_grid_import_kwh: number;
  total_grid_export_kwh: number;
  total_battery_charged_kwh: number;
  total_battery_discharged_kwh: number;
  day_count: number;
  total_curtailed_kwh: number;
  total_curtailed_hours: number;
  curtailment_value_dollars: number;
  uptime_pct: number;
  critical_count: number;
  warning_count: number;
  info_count: number;
  sent_count: number;
  resolved_count: number;
  daily_trend: DailyTrendPoint[] | null;
  battery_capacity_kwh: number | null;
  battery_degradation_pct: number | null;
  battery_cycles: number | null;
  battery_snapshot_at: string | null;
  rate_cents_per_kwh: number;
  rate_source_resolved: string;
  self_consumption_pct: number;
  estimated_savings_dollars: number;
  co2_avoided_kg: number;
  trees_equivalent: number;
}

export interface DailyTrendPoint {
  local_date: string;
  pv_kwh: number;
  load_kwh: number;
  grid_import_kwh: number;
  grid_export_kwh: number;
  battery_charged_kwh: number;
  battery_discharged_kwh: number;
}

export function usePropertyAnalytics(propertyId: string | undefined, dateFrom: string, dateTo: string) {
  return useQuery({
    queryKey: ['analytics-property', propertyId, dateFrom, dateTo],
    queryFn: async (): Promise<PropertyAnalytics | null> => {
      if (!propertyId) return null;

      const { data, error } = await supabase.rpc('get_analytics_property_summary', {
        p_property_id: propertyId,
        p_date_from: dateFrom,
        p_date_to: dateTo,
      });

      if (error) throw error;
      return data as unknown as PropertyAnalytics;
    },
    enabled: !!propertyId,
    staleTime: 5 * 60 * 1000,
  });
}
